'use client';
var IDENT_ACCORDION_ITEM = "AccordionItem";
var itemDefaultProps = {};

export { IDENT_ACCORDION_ITEM, itemDefaultProps };
